<template>
  <div class="tabs">
    <div class="tabs__switchers">
      <div @click="setCurrentTab(cont.text.$path)" class="tabs__switcher" :class="{'selected': currentTab === cont.text.$path}" v-for="cont in content"> {{ cont.text.title }}</div>
    </div>
    <div class="tabs__contents">
      <div class="tabs__content" v-for="cont in content" v-show="cont.text.$path ==currentTab" :class="{'selected': currentTab === cont.text.$path}">
        <div class="cols cols_2" v-if="cont.text.text_left_col">
          <div class="col" v-html="cont.text.text_left_col"></div>
          <div class="col" v-if="cont.text.text_right_col" :class="{'static': isIE()}" v-html="cont.text.text_right_col"></div>
        </div>
        <div v-if="cont.text.text_content" v-html="cont.text.text_content"></div>
        <div v-if="cont.text.$path === 'investors' ">
          <Investors :content="cont"></Investors>
        </div>
        <div v-if="cont.text.$path === 'whyelbruscapital' " class="elbrus-benefits">
          <div v-if="cont.text.text_benefit_1" class="elbrus-benefits__item" v-html="cont.text.text_benefit_1"></div>
          <div v-if="cont.text.text_benefit_2" class="elbrus-benefits__item" v-html="cont.text.text_benefit_2"></div>
          <div v-if="cont.text.text_benefit_3" class="elbrus-benefits__item">
            <div class="cols cols_2">
              <div class="col" v-html="cont.text.text_benefit_3"></div>
              <div class="col">
                <div class="companies">
                  <div class="companies__item" :style="`animation-name: companyAnimation${key + 1}; animation-delay: ${(key * 900)/1000}s`" v-for="(project, key) in projects.item" v-if="key < 5">
                    <img :src="project.text.item.logo_black.$src" v-if="project.text.item.logo_black" alt=""/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="cont.text.text_benefit_4" class="elbrus-benefits__item" v-html="cont.text.text_benefit_4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import browserDetect from '@/helpers/browserDetect';
  import Investors from '@/components/Investors';

  export default {
    name: 'tabs',
    props: ['content'],
    data() {
      return {
        currentIndex: 'company',
      };
    },
    components: { Investors },
    computed: mapGetters({
      projects: 'projects',
      currentTab: 'currentTab',
    }),
    methods: {
      setCurrentTab(tab) {
        this.$store.commit('SET_CURRENT_TAB', tab);
        this.currentIndex = tab;
      },
      isIE() {
        const ieCheck = (browserDetect() === 'ie');
        return ieCheck;
      },
    },
  };
</script>

<style>
  @keyframes companyAnimation1 {
    0% {
      opacity: 0;
      left: 0;
      bottom: 0;
      transform: scale(0);
    }
    40% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      left: 55%;
      bottom: 55%;
      transform: scale(1);
    }
  }
  @keyframes companyAnimation2 {
    0% {
      opacity: 0;
      left: 0;
      bottom: 0;
      transform: scale(0);
    }
    40% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      left: 40%;
      bottom: 40%;
      transform: scale(0.85);
    }
  }
  @keyframes companyAnimation3 {
    0% {
      opacity: 0;
      left: 0;
      bottom: 0;
      transform: scale(0);
    }
    40% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      left: 22%;
      bottom: 22%;
      transform: scale(0.6);
    }
  }
  @keyframes companyAnimation4 {
    0% {
      opacity: 0;
      left: 0;
      bottom: 0;
      transform: scale(0);
    }
    40% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      left: 10%;
      bottom: 10%;
      transform: scale(0.4);
    }
  }
  @keyframes companyAnimation5 {
    0% {
      opacity: 0;
      left: 0;
      bottom: 0;
      transform: scale(0);
    }
    40% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      left: 0;
      bottom: 0;
      transform: scale(0.3);
    }
  }

  .elbrus-benefits {
    &__item {
      margin-top: 60px;

      &:first-child {
        margin-top: 0;
      }
    }
  }

  .companies {
    position: relative;
    width: 100%;
    height: 400px;

    &__item {
      position: absolute;
      width: 300px;
      height: 300px;
      left: 0;
      bottom: 0;
      opacity: 0;
      transform: scale(0);
      border: 1px solid #000;
      border-radius: 50%;
      text-align: center;
      animation-duration: 5s;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;
      transform-origin: left bottom;

      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        height: 100%;

      }

      img {
        max-width: 50%;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }

  .tabs {
    overflow: hidden;

    &__switchers {
      background: rgba(255, 255, 255, 0.1);
      white-space: nowrap;
    }
    
    &__switcher {
      display: inline-block;
      vertical-align: top;
      white-space: nowrap;
      padding: 25px 80px;
      text-align: center;
      cursor: pointer;
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      transition: background 0.2s cubic-bezier(0.455, 0.065, 0.000, 0.990);

      &:not(.selected):hover {
        background: rgba(255, 255, 255, 0.3);
      }

      &.selected {
        cursor: default;
        background: #fff;
        color: #000;
      }
    }

    &__contents {
      background: #fff;
      color: #000;
      padding: 90px 100px;
    }

    &__content {
      position: relative;
    }
  }

  @media (max-width: 1400px) {
    .tabs {
      &__switcher {
        padding-left: 5%;
        padding-right: 5%;
      }
    }
  }

  @media (max-width: 1080px) {
    .tabs {
      &__switcher {
        padding-left: 2.7%;
        padding-right: 2.7%;
      }
    }
  }

  @media (max-width: 850px) {
    .tabs {
      margin: 0 -25px;

      &__switcher {
        display: block;
        padding: 25px;
        text-align: left;

        &:not(.selected) {
          border-bottom: 1px solid #fff;
        }

        &.selected:last-child {
          position: relative;

          &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            border-bottom: 1px solid #570803;
          }
        }
      }

      &__contents {
        background: #fff;
        color: #000;
        padding: 25px;
      }
    }

    .companies {
      height: 540px;
    }
  }


  @media (max-width: 600px) {
    .companies {
      height: 400px;
      
      &__item {
        width: 200px;
        height: 200px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Tabs.vue?946e1c34